import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import styles from '@styles/AdminPanel.module.css'
import PropTypes from 'prop-types'

const Dashboard = ({ dashboardData }) => {
  const chartData = [
    { name: 'Óptica', value: dashboardData.appointmentsByType.optica },
    { name: 'Domicilio', value: dashboardData.appointmentsByType.domicilio },
  ]

  return (
    <div className={styles.dashboard}>
      <h2>Dashboard</h2>
      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <h3>Total de Citas</h3>
          <p>{dashboardData.totalAppointments}</p>
        </div>
        <div className={styles.statCard}>
          <h3>Citas Próximas</h3>
          <p>{dashboardData.upcomingAppointments}</p>
        </div>
        <div className={styles.statCard}>
          <h3>Mensajes Recibidos</h3>
          <p>{dashboardData.totalMessages}</p>
        </div>
      </div>
      <div className={styles.chartContainer}>
        <h3>Citas por Tipo</h3>
        <ResponsiveContainer width='100%' height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis dataKey='name' />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey='value' fill='#8884d8' />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

Dashboard.propTypes = {
  dashboardData: PropTypes.object.isRequired,
}

export default Dashboard

